import { AuthProvider, ProtectedElement } from '@praxis/component-auth'
import { EnvProvider } from '@praxis/component-runtime-env'
import { envConfigs, ReactAppEnv } from 'apiConfig'
import { UserProvider } from './UserContext'
import PLMFederatedApolloProvider from '../graphql/PLMFederatedApolloProvider'
import { isPol, POLAccountSwitcher } from './POLAccountSwitcher'
import XAuthHydrator from './authComponents/XAuthHydrator'
import { authRoutes } from './authComponents/authConfig'
import LoginFailedPage from '../pages/LoginFailedPage'
import UnauthorizedPage from '../pages/UnauthorizedPage'
import { AppRouter } from '../router/AppRouter'
import { ToastAlertProvider } from '@design-systems/canvas-ui'
import { BackgroundActivityProvider } from 'components/backgroundActivity/organisms/BackgroundActivityContext'
import BasicErrorBoundary from './BasicErrorBoundary'

export const App = () => {
  const pathname = window.location.pathname.replace(/\/+$/, '')
  if (pathname === authRoutes.loginFailed) return <LoginFailedPage />
  if (pathname === authRoutes.unauthorized) return <UnauthorizedPage />

  return (
    <BasicErrorBoundary name="Root">
      <EnvProvider
        configPath={
          process.env.NODE_ENV === 'development'
            ? (process.env.REACT_APP_CONFIG_PATH ?? '/config.json')
            : '/app-environment'
        }
      >
        {({ env: { environment } }) => (
          <ToastAlertProvider>
            <AuthProvider
              {...(isPol
                ? envConfigs[environment as ReactAppEnv].pol.auth
                : envConfigs[environment as ReactAppEnv].auth)}
            >
              <UserProvider>
                <ProtectedElement>
                  <XAuthHydrator>
                    <POLAccountSwitcher>
                      <PLMFederatedApolloProvider>
                        <BackgroundActivityProvider>
                          <AppRouter environment={environment as ReactAppEnv} />
                        </BackgroundActivityProvider>
                      </PLMFederatedApolloProvider>
                    </POLAccountSwitcher>
                  </XAuthHydrator>
                </ProtectedElement>
              </UserProvider>
            </AuthProvider>
          </ToastAlertProvider>
        )}
      </EnvProvider>
    </BasicErrorBoundary>
  )
}
